//dependencias
import React, { Component } from 'react';

//componentes
import NombreAreaAction from './nombreAreas'

class Index extends Component {

    render(){
        return(
            <div>
                <NombreAreaAction />
            </div>
        );
    }

}
export default Index;